<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Elementos y Tarifario</h4>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de elementos y tarifario"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Elementos y Tarifario">
  <AyudaElemEmpr />
</Modal>

    <hr>

    <!--  DataTable  -->
    <DataTable
      :data="elememprs"
      :columns="columnas"
      idField="idElemEmpr"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      mensajeVacio="No hay elementos en el tarifario."
      @refresh="cargarTodos()"
      @create="abrirModalCrear()"
      @edit="row => abrirModalEditar(row.idElemEmpr)"
      @delete="row => deleteElemEmpr(row.idElemEmpr)"
    >
      <!-- Celda: Fecha vigencia -->
      <template #cell-fechaVig="{ row }">
        {{ getFormattedDate(row.fechaVig) }}
      </template>

      <!-- Celda: Estado -->
      <template #cell-estado="{ row }">
        <span :class="row.estado === 1 ? 'badge bg-success' : 'badge bg-secondary'">
          {{ getEstadoTexto(row.estado) }}
        </span>
      </template>
    </DataTable>

    <!--  Modal crear / editar  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalElemEmprLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalElemEmprLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- Info solo en modo editar -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label">Clasificación</label></div>
                <div class="col-2">
                  <span class="form-control-plaintext">{{ datoElemEmpr.clasElemNombre }}</span>
                </div>
                <div class="col-1"><label class="form-label">Código</label></div>
                <div class="col-3">
                  <span class="form-control-plaintext">{{ datoElemEmpr.elementoCodigo }}</span>
                </div>
                <div class="col-2"><label class="form-label">Fecha de Registro</label></div>
                <div class="col-2">
                  <span class="form-control-plaintext">{{ getFormattedDate(datoElemEmpr.fechaReg) }}</span>
                </div>
              </div>
            </div>

<!-- Reemplaza el bloque mb-3 del buscador de elemento -->
<div class="mb-3">
  <div class="row">
    <div class="col-2"><label class="form-label">Nombre Estándar</label></div>
    <div class="col-10">
      <div class="elem-selector-box" :class="{ 'is-open': selectorAbierto }">

        <!-- Trigger -->
        <div class="elem-selected" @click="selectorAbierto = !selectorAbierto">
          <span v-if="datoElemEmpr.idElemento" class="elem-pill">
            <i class="material-symbols-outlined" style="font-size:14px">check</i>
            <strong>{{ datoElemEmpr.elementoCodigo }}</strong> — {{ searchTextElemento }}
          </span>
          <span v-else class="elem-placeholder">Buscar por código o nombre...</span>
          <i class="material-symbols-outlined ms-auto"
             style="font-size:18px;transition:transform .2s"
             :style="selectorAbierto ? 'transform:rotate(180deg)' : ''">
            expand_more
          </i>
        </div>

        <!-- Panel de búsqueda -->
        <div class="elem-panel" v-if="selectorAbierto">
          <div class="elem-filters">
            <select class="form-select form-select-sm" v-model="filtroClase" @change="filterElementos" style="flex:0 0 160px">
              <option value="">Todas las clases</option>
              <option v-for="c in clasElems" :key="c.idClasElem" :value="c.nombre">
                {{ c.nombre }}
              </option>
            </select>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="searchTextElemento"
              @input="filterElementos"
              placeholder="Código o nombre..."
              ref="inputBuscador"
            >
          </div>
          <div class="elem-results">
            <div v-if="!filteredElementos.length" class="elem-empty">
              <i class="material-symbols-outlined">search_off</i>
              Sin resultados
            </div>
            <div
              v-for="el in filteredElementos.slice(0, 50)"
              :key="el.idElemento"
              class="elem-item"
              :class="{ active: datoElemEmpr.idElemento === el.idElemento }"
              @click="selectElemento(el)"
            >
              <span class="elem-code">{{ el.codigo }}</span>
              <span class="elem-clase">{{ el.clasElemNombre }}</span>
              <span class="elem-name">{{ el.nombre }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

            <!-- Nombre -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Nombre</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoElemEmpr.nombre">
                </div>
              </div>
            </div>

            <!-- Impuesto -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Impuesto</label></div>
                <div class="col-4">
                  <select class="form-control" v-model="datoElemEmpr.idImpuesto">
                    <option v-for="imp in impuestos" :value="imp.idImpuesto" :key="imp.idImpuesto">
                      {{ imp.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-sm"
                          @click="datoElemEmpr.idImpuesto = 1">IVA 0%</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-secondary btn-sm"
                          @click="datoElemEmpr.idImpuesto = 2">IVA 12%</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-success btn-sm"
                          @click="datoElemEmpr.idImpuesto = 3">IVA 15%</button>
                </div>
              </div>
            </div>

            <!-- Valor y Fecha de Vigencia -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Valor</label></div>
                <div class="col-4">
                  <input type="number" class="form-control" v-model="datoElemEmpr.valor" required>
                </div>
                <div class="col-2"><label class="form-label">Fecha de Vigencia</label></div>
                <div class="col-4">
                  <input type="date" class="form-control" v-model="datoElemEmpr.fechaVig">
                </div>
              </div>
            </div>

            <!-- Estado -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2"><label class="form-label">Estado</label></div>
                <div class="col-2">
                  <select class="form-select" v-model="datoElemEmpr.estado">
                    <option :value="1">Activo</option>
                    <option :value="0">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button" class="btn btn-success"
                    @click.prevent="guardarElemEmpr()">
              <span class="material-symbols-outlined align-middle" style="font-size:20px">save</span>
              Guardar
            </button>
            <button v-if="btnEditar" type="button" class="btn btn-success"
                    @click.prevent="guardarEditElemEmpr()">
              <span class="material-symbols-outlined align-middle" style="font-size:20px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import AyudaElemEmpr from '@/views/ayuda/AyudaElemEmpr.vue'
import DataTable     from '@/components/DataTable.vue'
import { validarForm }  from '@/modules/validacionesForms.js'
import dateFormat       from '@/modules/dateFormat.js'
import api              from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal             from 'sweetalert'

export default {
  name: 'ElemEmprs',
  components: { Layout, Footer, AyudaElemEmpr, DataTable },

  data() {
    return {
      elememprs:          [],
      datoElemEmpr:       {},
      titulo:             '',
      btnCrear:           false,
      btnEditar:          false,
      modalWindow:        true,
      showModalHelp:      false,
      elementos:          [],
      searchTextElemento: '',
      filteredElementos:  [],
      impuestos:          [],

      //  Columnas para DataTable
columnas: [
  { field: 'elementoCodigo', label: 'Código Estándar' },
  { field: 'elementoNombre', label: 'Nombre Estándar' },
  { field: 'nombre',         label: 'Nombre' },
  { field: 'valor',          label: 'Valor' },
  { field: 'fechaVig',       label: 'Vigencia' },
  {
    field: 'estado',
    label: 'Estado',
    filterType: 'select',
    filterOptions: [
      { label: 'Activo',   value: 1 },
      { label: 'Inactivo', value: 0 },
    ],
  },
],
selectorAbierto: false,
filtroClase:     '',
clasElems:       [],
    }
  },

  mounted() {
    this.cargarTodos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchElementos()
    this.fetchImpuestos()
    this.fetchClasElems()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    getEstadoTexto(estado) {
      return estado === 1 ? 'Activo' : 'Inactivo'
    },

    //  Carga de datos
    cargarTodos() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get(`/vwelememprs/idempresa/${idEmpresa}`)
        .then(response => { this.elememprs = response.data.reverse() })
        .catch(error   => console.error('Error al obtener elementos:', error))
    },

    fetchElementos() {
      api.get('/vwelementos')
        .then(response => {
          this.elementos         = response.data
          this.filteredElementos = response.data
        })
        .catch(error => console.error('Error al obtener elementos:', error))
    },

    fetchImpuestos() {
      api.get('/vwimpuestos')
        .then(response => { this.impuestos = response.data })
        .catch(error   => console.error('Error al obtener impuestos:', error))
    },

fetchClasElems() {
  api.get('/vwclaselems')
    .then(r => { this.clasElems = r.data })
    .catch(e => console.error('Error fetching clasElems:', e))
},

filterElementos() {
  const q     = this.searchTextElemento.toLowerCase().trim()
  const clase = this.filtroClase
  this.filteredElementos = this.elementos.filter(e => {
    const okClase = !clase || e.clasElemNombre === clase
    const okTexto = !q || e.nombre.toLowerCase().includes(q) || e.codigo.toLowerCase().includes(q)
    return okClase && okTexto
  })
},

selectElemento(elemento) {
  this.datoElemEmpr.idElemento     = elemento.idElemento
  this.datoElemEmpr.nombre         = elemento.nombre
  this.datoElemEmpr.clasElemNombre = elemento.clasElemNombre
  this.datoElemEmpr.elementoCodigo = elemento.codigo
  this.searchTextElemento          = elemento.nombre
  this.selectorAbierto             = false
},

    //  Validación
    validarForm() {
      return validarForm(
        this.datoElemEmpr,
        ['idElemento', 'fechaVig', 'valor'],
        ['Nombre Estándar', 'fechaVig', 'valor']
      )
    },

    //  CRUD
    async guardarElemEmpr() {
      if (this.validarForm() !== 1) return
      try {
        this.datoElemEmpr.idEmpresa = window.sessionStorage.getItem('idEmpresa')
        await api.post('/elememprs', this.datoElemEmpr)
        closeModal('ventanaModal')
        swal('Correcto!', 'Elemento creado exitosamente!', 'success')
        this.cargarTodos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditElemEmpr() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/elememprs', this.datoElemEmpr)
        closeModal('ventanaModal')
        swal('Correcto!', 'Elemento actualizado exitosamente!', 'success')
        this.cargarTodos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async deleteElemEmpr(idElemEmpr) {
      try {
        await api.delete(`/elememprs/${idElemEmpr}`)
        this.cargarTodos()
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error')
      }
    },

    //  Apertura de modal
abrirModalCrear() {
  this.modalWindow        = true
  this.selectorAbierto    = false
  this.filtroClase        = ''
  this.searchTextElemento = ''
  this.filteredElementos  = this.elementos
  this.titulo             = 'Crear Elemento'
  this.btnCrear           = true
  this.btnEditar          = false

  // Valores por defecto
  const hoy = new Date().toISOString().split('T')[0]
  this.datoElemEmpr = {
    fechaVig: hoy,
    estado:   1,
  }

  openModal('ventanaModal')
},

    abrirModalEditar(idElemEmpr) {
      this.modalWindow = true
      if (idElemEmpr) {
        api.get(`/vwelememprs/${idElemEmpr}`).then(resp => {
          this.datoElemEmpr       = resp.data
          this.searchTextElemento = resp.data.elementoNombre
          this.datoElemEmpr.fechaVig = dateFormat.getFormattedDateISO(resp.data.fechaVig)
        })
      }
      this.titulo    = 'Editar Elemento'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada02.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.elem-selector-box { border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden; }
.elem-selected { display: flex; align-items: center; gap: 8px; padding: 7px 10px; cursor: pointer; background: #f8f9fa; min-height: 38px; }
.elem-selected:hover { background: #e9ecef; }
.elem-placeholder { font-size: 13px; color: #6c757d; }
.elem-pill { display: inline-flex; align-items: center; gap: 6px; background: #cfe2ff; border-radius: 4px; padding: 2px 8px; font-size: 13px; color: #0a3880; }
.elem-panel { border-top: 1px solid #dee2e6; }
.elem-filters { display: flex; gap: 8px; padding: 8px; background: #f8f9fa; border-bottom: 1px solid #dee2e6; }
.elem-results { max-height: 200px; overflow-y: auto; }
.elem-item { display: flex; align-items: center; gap: 10px; padding: 8px 10px; cursor: pointer; border-bottom: 1px solid #f2f2f2; }
.elem-item:hover, .elem-item.active { background: #f0f4ff; }
.elem-code { font-size: 11px; font-weight: 600; color: #0d6efd; background: #e7f1ff; border-radius: 3px; padding: 2px 5px; min-width: 52px; text-align: center; flex-shrink: 0; }
.elem-clase { font-size: 11px; color: #6c757d; flex-shrink: 0; min-width: 60px; }
.elem-name { font-size: 13px; flex: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.elem-empty { padding: 16px; text-align: center; color: #6c757d; font-size: 13px; }
</style>